import correct from '@/assets/img/documents/house-hold/faktura.jpg';
import wrong from '@/assets/img/documents/house-hold/faktura-wrong.jpg';

import Card from '@/components/Card';
import { Uploader } from '@/components/ui/Uploader/Uploader';
import { ATTACHMENT_TYPES } from '@/consts';

import { useLingui } from '@lingui/react';

export const INVOICES_NAME = 'invoices';

const Invoices = () => {
  const { i18n } = useLingui();

  const instructionProps = {
    title: i18n.t('Jak poprawnie dodać faktury, rachunki i ekspertyzy?'),
    steps: [
      i18n.t('Sprawdź, czy załączasz wszystkie strony.'),
      i18n.t('Jeśli przesyłasz zdjęcia – sprawdź, czy dokument jest czytelny.'),
      i18n.t('Jeśli plik jest zabezpieczony – dołącz hasło.'),
    ],
    correctImg: correct,
    wrongImg: wrong,
  };

  return (
    <div>
      <Card>
        <Uploader
          title={i18n.t('Faktury, rachunki, ekspertyzy')}
          instructionProps={instructionProps}
          inputFieldName={INVOICES_NAME}
          required
          attachmentTypeId={ATTACHMENT_TYPES.RACHUNKIFAKTURY}
          data-testid={`${INVOICES_NAME}-uploader`}
        />
      </Card>
    </div>
  );
};

export default Invoices;
